import {booleanAttribute, Component, Input} from '@angular/core'
import {faInfoCircle} from '@fortawesome/pro-solid-svg-icons/faInfoCircle'

@Component({
  selector: 'cft-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css'],
  standalone: false,
})
export class MessageComponent {
  @Input() icon? = faInfoCircle
  @Input() title?: string
  @Input() colour?: MessageColour = 'blue'
  @Input() layout: 'vertical' | 'horizontal' = 'horizontal'
  @Input({transform: booleanAttribute}) hasFooter = false
}

type MessageColour = 'blue' | 'orange' | 'grey'
